import { useSelector } from 'react-redux';
import { getLotteryElement } from 'core/ducks/lottery';
import { IStore } from 'store/interface';
import { ILotteryEntity } from 'core/interfaces';

export const useLotteryElement = (identifier: number) => ({
  data: useSelector<IStore, ILotteryEntity>(getLotteryElement(identifier)),
});
